module.exports = __webpack_public_path__ + "img/DK15966637.f4ea5972.png";